import React from 'react';
import { NavLink } from "react-router-dom";
import { ReactComponent as DeleteIcon } from "../../assets/icons/delete.svg";
import { ReactComponent as ConsoleIcon } from "../../assets/icons/console.svg";
import { ReactComponent as PowerIcon } from "../../assets/icons/power.svg";
import Header from './Header';
import ActionButton from '../Buttons/ActionButton';
import Tooltip from '../Tooltip/Tooltip';
import { useDevice } from '../../Api/newSockets.api';

type Props = {
  device: any
}

const DevicesHeader = (props:Props)=> {
    const { updateDevice } = useDevice();

    const handleNameChange = async (newName: string) => {
      if (props.device?.id && newName !== props.device?.name) {
        try {
          await updateDevice(props.device.id, { name: newName });
        } catch (error) {
          console.error('Failed to update device name:', error);
        }
      }
    };

    return (
      <Header
        title={props.device?.name}
        goBackTo={"/devices"}
        editable={true}
        onTitleChange={handleNameChange}
        mainAction={
          <>
            <ActionButton icon={<PowerIcon className={`${props.device?.Status && "online"}`} />} className="list-item-action" />
            {props.device?.id && (
              <Tooltip content="View logs">
                <NavLink to={`/devices/${props.device.id}/logs`}>
                  <ActionButton icon={<ConsoleIcon />} className="list-item-action logs-action" />
                </NavLink>
              </Tooltip>
            )}
            <ActionButton icon={<DeleteIcon />} className="list-item-action" />
          </>
        }
      />
    )
};

export default DevicesHeader;